import { Hammer, Target, UserCheck, FileText } from "lucide-react";
import { ChapterLabel } from "./ChapterLabel";
import { Reveal } from "./Reveal";

const REASONS = [
  {
    icon: Hammer,
    title: "We build, not just audit",
    text: "Most audits hand you a list of problems. If your website is the problem, we can design and build you a fast, mobile-first one that turns visitors into calls.",
  },
  {
    icon: Target,
    title: "Built for service businesses",
    text: "We only work with service-based businesses — contractors, plumbers, HVAC, and the trades — so every report is about calls, quotes, and jobs. Never vanity metrics.",
  },
  {
    icon: UserCheck,
    title: "A real person, every month",
    text: "You get a walkthrough call with Owen every month — not a dashboard you're left to decode alone.",
  },
  {
    icon: FileText,
    title: "Nothing to decode",
    text: "Plain-English reports. If a number doesn't help you get or keep customers, it doesn't make the report.",
  },
];

export const WhyChooseUs = () => (
  <section id="why-og" className="py-24 sm:py-32" data-testid="why-choose-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal>
        <ChapterLabel text="Chapter 05 // Why Us" />
        <h2 className="font-display text-3xl sm:text-5xl font-bold tracking-tight leading-tight text-white mb-16">
          Why Choose OG Solutions
        </h2>
      </Reveal>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
        {REASONS.map((r, i) => (
          <Reveal key={r.title} delay={i * 0.08}>
            <div
              data-testid={`why-choose-card-${i + 1}`}
              className="group h-full rounded-2xl sm:rounded-3xl border border-white/10 bg-[#0F1B31]/70 p-8 sm:p-10 transition-all duration-300 hover:-translate-y-1 hover:border-white/30"
            >
              <span className="mb-8 inline-flex h-12 w-12 items-center justify-center rounded-full border border-white/15 bg-white/[0.05] text-white transition-colors duration-300 group-hover:bg-white group-hover:text-[#060D1A]">
                <r.icon className="h-5 w-5" />
              </span>
              <h3 className="font-display text-xl sm:text-2xl font-semibold tracking-tight text-white mb-3">
                {r.title}
              </h3>
              <p className="text-base text-slate-400 leading-relaxed">{r.text}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
